const HISTORY_RETRY_DELAY_MS = 350;

type HistoryMethodName = "pushState" | "replaceState";
type PendingHistoryCall = {
  data: unknown;
  unused: string;
  url?: string | URL | null;
};

const isWebKitHistoryRateLimitError = (error: unknown) => {
  return (
    error instanceof DOMException &&
    error.name === "SecurityError" &&
    error.message.includes("history.") &&
    error.message.includes("more than 100 times")
  );
};

const patchHistoryMethod = (methodName: HistoryMethodName) => {
  const original = window.history[methodName];
  let pendingCall: PendingHistoryCall | null = null;
  let retryTimer: number | null = null;

  const flushPendingCall = () => {
    retryTimer = null;

    if (!pendingCall) {
      return;
    }

    const { data, unused, url } = pendingCall;
    pendingCall = null;

    try {
      original.call(window.history, data, unused, url);
    } catch (error) {
      if (!isWebKitHistoryRateLimitError(error)) {
        throw error;
      }

      pendingCall = { data, unused, url };
      retryTimer = window.setTimeout(flushPendingCall, HISTORY_RETRY_DELAY_MS);
    }
  };

  window.history[methodName] = function (
    data: unknown,
    unused: string,
    url?: string | URL | null,
  ) {
    try {
      return original.call(window.history, data, unused, url);
    } catch (error) {
      if (!isWebKitHistoryRateLimitError(error)) {
        throw error;
      }

      pendingCall = { data, unused, url };

      if (retryTimer === null) {
        retryTimer = window.setTimeout(flushPendingCall, HISTORY_RETRY_DELAY_MS);
      }
    }
  };
};

export const guardHistoryRateLimit = () => {
  if (typeof window === "undefined") {
    return;
  }

  patchHistoryMethod("replaceState");
  patchHistoryMethod("pushState");
};
